import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { FC } from 'react'

import { useGetBillToLocationUrl } from '@user/store/authorization/hooks'
import { selectAllPayments } from '@user/store/payments/slice'
import { useSelector } from 'react-redux'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

const getStyles = (theme: Theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  subtitle: {
    color: '#007bff',
    cursor: 'pointer',
    fontSize: '14px',
  },

  title: {
    fontSize: '18px',
    fontFamily: 'Source Sans Pro Bold',
  },
})

interface Props {
  handleAddPayment: () => void
  billToId: string
  canUpdate: boolean
}

export const PaymentMethodsTableHeader: FC<Props> = (props) => {
  const { handleAddPayment, billToId, canUpdate } = props
  const paymentMethods = useSelector(selectAllPayments)

  const locationUrl = useGetBillToLocationUrl(billToId)

  const onClick = React.useCallback(
    () => window.open(locationUrl, '_blank'),
    [locationUrl],
  )
  const styles = getStyles(useTheme())
  return (
    <>
      {paymentMethods.length > 0 && (
        <Box sx={styles.root} display="flex" alignItems="center" p={2}>
          <Box flexGrow={1}>
            <Typography sx={styles.title}>Payment Methods on File</Typography>
            {canUpdate && (
              <Typography sx={styles.subtitle} onClick={handleAddPayment}>
                Capture Card
              </Typography>
            )}
          </Box>
          <Box>
            <Button color="primary" onClick={onClick} variant="outlined">
              Manage in PestPac
            </Button>
          </Box>
        </Box>
      )}
    </>
  )
}

PaymentMethodsTableHeader.displayName = 'PaymentMethodsTableHeader'
